export const EmailNotificationsGroupTitlePropMap = {
    email: 'Email',
    name: 'Name',
    abacusId: 'Abacus ID',
    dateLastModified: 'Date Last Modified',
    user: 'User',
    remove: 'Remove'
};

export const EmailNotificationsGroupPropMap = {
    email: 'extId',
    name: 'name',
    abacusId: 'extId',
    dateLastModified: 'lastUpdated',
    user: 'updatedBy',
    remove: 'remove',
    extId: 'extId'
};

export const EmailNotificationsGroupFilterPropMap: { [key: string]: string } = {
    id: 'id',
    name: 'name',
    extId: 'extId',
    groupType: 'groupType',
    openEvent: 'openEvent',
    closeEvent: 'closeEvent',
    reopenEvent: 'reopenEvent',
    endEvent: 'endEvent',
    updatedBy: 'updatedBy',
    lastUpdated: 'lastUpdated'
};

export const EmailNotificationsGroupSortPropMap: { [key: string]: string } = {
    ...EmailNotificationsGroupFilterPropMap
};
